__turbopack_context__.v({
  "ascii": "ErrorPage-module__Q5vb2a__ascii",
  "blink": "ErrorPage-module__Q5vb2a__blink",
  "blinkStep": "ErrorPage-module__Q5vb2a__blinkStep",
  "body": "ErrorPage-module__Q5vb2a__body",
  "card": "ErrorPage-module__Q5vb2a__card",
  "caret": "ErrorPage-module__Q5vb2a__caret",
  "code": "ErrorPage-module__Q5vb2a__code",
  "container": "ErrorPage-module__Q5vb2a__container",
  "cursor": "ErrorPage-module__Q5vb2a__cursor",
  "footer": "ErrorPage-module__Q5vb2a__footer",
  "header": "ErrorPage-module__Q5vb2a__header",
  "headerCode": "ErrorPage-module__Q5vb2a__headerCode",
  "headerTitle": "ErrorPage-module__Q5vb2a__headerTitle",
  "joke": "ErrorPage-module__Q5vb2a__joke",
  "jokeLabel": "ErrorPage-module__Q5vb2a__jokeLabel",
  "jokeText": "ErrorPage-module__Q5vb2a__jokeText",
  "link": "ErrorPage-module__Q5vb2a__link",
  "linkPrimary": "ErrorPage-module__Q5vb2a__linkPrimary",
  "message": "ErrorPage-module__Q5vb2a__message",
  "redDot": "ErrorPage-module__Q5vb2a__redDot",
  "terminal": "ErrorPage-module__Q5vb2a__terminal",
  "terminalPrompt": "ErrorPage-module__Q5vb2a__terminalPrompt",
  "title": "ErrorPage-module__Q5vb2a__title",
  "wrapper": "ErrorPage-module__Q5vb2a__wrapper",
  "yellowDot": "ErrorPage-module__Q5vb2a__yellowDot",
});
